// extracted by mini-css-extract-plugin
export default {"Choice":"Choice_Choice__113Yk","answer":"Choice_answer__JnQYM","Loading":"Choice_Loading__gSeas","load":"Choice_load__Piw7Y"};